import { accountReducer, AccountState } from './account/reducer';
import { authReducer, AuthState } from './auth/reducer';
import { applicationReducer as appReducer, ApplicationState as AppState } from './application/reducer';
import { all, fork } from 'redux-saga/effects';
import appSaga from './application/sagas';
import accountSaga from './account/sagas';
import authSaga from './auth/sagas';
import { ticketReducer, TicketState } from './ticket/reducer';
import ticketSaga from './ticket/sagas';
import documentSaga from './document/sagas';
import { clientReducer, ClientState } from './client/reducer';
import clientSaga from './client/sagas';
import { tariffReducer, TariffState } from './tariff/reducer';
import tariffSaga from './tariff/sagas';
import eWalletSaga from './e-wallet/sagas';
import couponSaga from './coupon/sagas';
import { faqReducer, FaqState } from './faq/reducer';
import faqSaga from './faq/sagas';
import { sellingReducer, SellingState } from './selling/reducer';
import sellingSaga from './selling/sagas';
import { penaltyReducer, PenaltyState } from './penalty/reducer';
import penaltySaga from './penalty/sagas';

export interface ApplicationState {
    auth: AuthState;
    account: AccountState;
    application: AppState;
    client: ClientState;
    ticket: TicketState;
    tariff: TariffState;
    faq: FaqState;
    selling: SellingState;
    penalty: PenaltyState;
}

export const reducers = {
    auth: authReducer,
    account: accountReducer,
    application: appReducer,
    client: clientReducer,
    ticket: ticketReducer,
    tariff: tariffReducer,
    faq: faqReducer,
    selling: sellingReducer,
    penalty: penaltyReducer
};

export function* saga() {
    yield all([
        fork(appSaga),
        fork(accountSaga),
        fork(authSaga),
        fork(clientSaga),
        fork(documentSaga),
        fork(eWalletSaga),
        fork(ticketSaga),
        fork(couponSaga),
        fork(tariffSaga),
        fork(faqSaga),
        fork(sellingSaga),
        fork(penaltySaga)
    ]);
}
